import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import afrRatings from "../../../../src/data/articles/cube-prospective-adventures-in-the-forgotten-realms/afr-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  afrRatings,
  ProspectiveIntro,
  React
};